<template>
  <div class="card card-chart">
    <div
      class="progress-container w-100 progress"
      v-if="view === 'random'"
    >
      <div
        v-if="progressBar.isVisible"
        class="progress-bar"
        :class="{'progress-bar-active': progressBar.isActive}"
        :style="{transition: `all linear ${5}s`, background: COLORS.green}"
      ></div>
    </div>
    <div
      class="card-body d-flex flex-column justify-content-between h-100 mb-3"
      :class="{'bg-secondary': selectItemLinkMode}"
    >
      <div class="h-100">
        <div v-if="!selectItemLinkMode">
          <div v-if="textualItems.length > 0">
            <div class="d-flex align-items-center justify-content-between mb-3">
              <h5 class="p-0 m-0 mr-3">
                {{ selectedItemLink.title }}
              </h5>
            </div>
            <div class="d-flex justify-content-end">
              <div class="mr-2">
                <v-button
                  v-if="textualItems.length > 1 && view !== 'all'"
                  icon="edit"
                  id="open-answer-other-question"
                  text="phrase.other_question"
                  size="xs"
                  style-type="link"
                  @click="selectItemLinkMode = true"
                />
              </div>
              <div>
                <v-button
                  text="phrase.all_answers"
                  id="open-answer-all-anwers"
                  style-type="link"
                  icon="list"
                  size="xs"
                  :disabled="selectedAnswers.length === 0"
                  v-if="view !== 'all'"
                  @click="view = 'all'"
                />
              </div>
              <v-button
                text="word.back"
                id="open-answer-back"
                size="xs"
                style-type="secondary"
                icon="chevron-left"
                v-if="view === 'all'"
                @click="disableAllAnswersView()"
              />
            </div>
          </div>
          <div v-else>
            {{ $t('sentence.no_open_items') }}
          </div>
        </div>
        <div
          class="h-100 text-white"
          v-if="selectItemLinkMode"
        >
          <div class="d-flex justify-content-between align-items-center mb-3">
            <h5 class="p-0 m-0">{{ $t('phrase.select_question') }}</h5>
            <v-button
              id="open-answer-disable-other-question"
              icon="times"
              size="xs"
              style-type="link text-white"
              @click="disableSelectItemLinkMode()"
            />
          </div>

          <table class="table table-striped">
            <tr
              v-for="(itemLink, index) in textualItems"
              :key="itemLink.id"
            >
              <td class="text-white">
                {{ itemLink.title }}
              </td>
              <td>
                <v-button
                  :id="`open-answer-${index}`"
                  style-type="dark"
                  size="xs"
                  :block="true"
                  :text="`word.${selectedItemLinkIndex !== index ? 'select' : 'selected'}`"
                  :disabled="selectedItemLinkIndex === index"
                  @click="selectItemLink(index)"
                />
              </td>
            </tr>
          </table>
        </div>
        <div
          v-else-if="selectedAnswers.length > 0"
          class="d-flex card-open-answer-body pt-3 overflow-auto"
        >
          <div class="w-100" v-if="view === 'random'">
            <div
              class="open-answer-content d-flex justify-content-center align-items-start"
            >
              <transition name="fade-slow-nl">
                <div class="text-center" v-if="selectedAnswer">
                  <h3 class="p-0 text-muted">
                    "{{ (selectedAnswer.value_cleaned || selectedAnswer.value_str).trim() }}"
                    <span
                      class="text-info font-italic"
                      v-if="selectedAnswer.value_cleaned"
                    >
                      <small>{{ $t('word.edited') }}</small>
                    </span>
                  </h3>
                  <div class="text-muted">--</div>
                  <div class="text-muted">
                    {{ stringToPrettyDateTime(selectedAnswer.reviewed) }}
                  </div>
                </div>
              </transition>
            </div>
          </div>
          <div v-if="view === 'all'" class="w-100">
            <v-item-data-raw
              :answers="selectedAnswers"
              renderType="text"
            />
          </div>
        </div>
        <div
          v-else
          class="d-flex flex-column h-100 w-100 justify-content-center
           align-items-center text-muted"
        >
          <i class="fa fa-folder-open icon-large mb-2"></i>
          <div>
            {{ $t('sentence.no_open_answers') }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Button from '@/common/components/Button.vue';
import ItemDataRawWidget from '@/organisation/components/research/widgets/ItemDataRawWidget.vue';
import { COLORS } from '@/common/utils/constants';
import { mapGetters } from 'vuex';
import { stringToPrettyDateTime } from '@/common/utils/formatting';

export default {
  name: 'OpenAnswerWidget',
  components: {
    'v-button': Button,
    'v-item-data-raw': ItemDataRawWidget,
  },
  data() {
    return {
      COLORS,
      selectedItemLinkIndex: null,
      selectItemLinkMode: false,
      selectedAnswer: null,
      answers: null,
      timeOut: null,
      view: 'random',
      progressBar: {
        isActive: false,
        isVisible: true,
      },
    };
  },
  methods: {
    stringToPrettyDateTime,
    disableSelectItemLinkMode() {
      this.selectItemLinkMode = false;
      clearTimeout(this.timeOut);
      this.progressBar.isActive = false;
      this.progressBar.isVisible = true;
      this.timeOut = setTimeout(this.initShowRandomAnswer, 20);
    },
    disableAllAnswersView() {
      this.view = 'random';
      clearTimeout(this.timeOut);
      this.progressBar.isActive = false;
      this.progressBar.isVisible = true;
      this.timeOut = setTimeout(this.initShowRandomAnswer, 20);
    },
    initShowRandomAnswer(excludedId) {
      clearTimeout(this.timeOut);
      this.progressBar.isVisible = true;
      this.timeOut = setTimeout(() => this.showRandomAnswer(excludedId), 20);
    },
    hideCurrentAnswer() {
      clearTimeout(this.timeOut);
      this.progressBar.isActive = false;
      this.progressBar.isVisible = false;
      const currentAnswerId = this.selectedAnswer.id;
      this.selectedAnswer = null;
      this.timeOut = setTimeout(() => this.initShowRandomAnswer(currentAnswerId), 20);
    },
    selectItemLink(index) {
      this.selectItemLinkMode = false;
      this.selectedItemLinkIndex = index;
    },
    showRandomAnswer(excludedId) {
      clearTimeout(this.timeOut);
      this.progressBar.isActive = true;
      const answers = this.selectedAnswers
        .filter((ans) => (ans.id !== excludedId));
      if (answers.length > 0) {
        this.selectedAnswer = answers[Math.floor(Math.random() * answers.length)];
        if (this.selectedAnswers.length > 1) {
          this.timeOut = setTimeout(this.hideCurrentAnswer, 5000);
        }
      }
    },
  },
  watch: {
    selectedItemLinkIndex() {
      if (this.selectedAnswers.length > 0) {
        clearTimeout(this.timeOut);
        this.progressBar.isActive = false;
        this.progressBar.isVisible = true;
        this.timeOut = setTimeout(this.initShowRandomAnswer, 20);
      }
    },
  },
  computed: {
    ...mapGetters('researches', [
      'data',
      'researchItems',
    ]),
    textualItems() {
      return this.researchItems.filter(
        (researchItem) => researchItem.item.render_type === 'text',
      );
    },
    selectedAnswers() {
      return this.data.answersByResearchItem[this.selectedItemLink.id] || [];
    },
    selectedItemLink() {
      return this.textualItems[this.selectedItemLinkIndex];
    },
  },
  created() {
    if (this.textualItems && this.textualItems.length > 0) {
      this.selectedItemLinkIndex = 0;
    }
    this.timeOut = setTimeout(this.initShowRandomAnswer, 20);
  },
};
</script>


<style scoped>
.progress-bar {
  width: 0;
}

.progress-bar-active {
  width: 100%;
}

.card-open-answer-body {
  height: 270px;
}

.open-answer-content {
  height: 250px;
  overflow-y: auto;
}
</style>
